export default __webpack_public_path__ + "static/media/apim-loading-animation.c47df870.gif";